"use client";

import Link from "next/link";
import { useParams } from "next/navigation";

import React from "react";

import { DEFAULT_URL_PREFIX } from "@core/constants";

export const ErrorPage = () => {
  const { locale } = useParams<{ locale: string }>();

  return (
    <section className="max-w-(--container-width) h-[50vh] ml-auto mr-auto px-4 text-contentPrimary">
      <div className="flex flex-col gap-4 items-center justify-center h-full text-center">
        <h1 className="text-4xl font-medium">Oops! You’ve hit a dead end.</h1>
        <div className="md:text-2xl font-medium text-xl">
          We couldn’t find that page.
        </div>
        <div className="text-base font-regular text-contentSecondary">
          Try searching or head back to{" "}
          <Link
            className="text-contentInformation"
            href={`/${locale ?? DEFAULT_URL_PREFIX}`}>
            buycycle’s homepage
          </Link>{" "}
          to get back on track.
        </div>
      </div>
    </section>
  );
};
